export default function FilterSearchReport({name,values,updateState}) {
  return (
      <div className="flex flex-col gap-1">

          {/* Column Title */}
          <span className="font-bold text-xs uppercase tracking-wider whitespace-nowrap">
              {name}
          </span>

          {/* Inline Search Input */}
          <input
              type="text"
              placeholder="Search..."
              value={values}
              onChange={(e) => updateState(e.target.value)}
              className="w-44 mx-auto px-2 py-1 text-sm rounded-md border border-gray-300 text-primary-400
                 focus:outline-none focus:ring-1 focus:ring-primary-400 
                 placeholder-gray-400"
          />

      </div>
  )
}
